export const LOGIN_COMPONENT = 'LOGIN_COMPONENT';
export const REGISTER_COMPONENT = 'REGISTER_COMPONENT';
export const U_PROFILE_COMPONENT = 'U_PROFILE_COMPONENT';
export const PROFILE_COMPONENT = 'PROFILE_COMPONENT';
export const PAYMENT_COMPONENT = 'PAYMENT_COMPONENT';
export const OTP_COMPONENT = 'OTP_COMPONENT';
export const SET_PASSWORD_COMPONENT = 'SET_PASSWORD_COMPONENT';
export const FORGOT_PASSWORD_COMPONENT = 'FORGOT_PASSWORD_COMPONENT';
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
